import { render } from "./TeamPermissionsPage.vue?vue&type=template&id=1b91a07c&scoped=true"
import script from "./TeamPermissionsPage.vue?vue&type=script&lang=js"
export * from "./TeamPermissionsPage.vue?vue&type=script&lang=js"

import "./TeamPermissionsPage.vue?vue&type=style&index=0&id=1b91a07c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b91a07c"]])

export default __exports__